import React, { useState, useEffect } from 'react';
import './ImageGrid.css'; // Reusing the same CSS

const InteriorGallery = ({ title, description }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    // Function to import all images from the interior folder
    const importAllImages = async () => {
      try {
        // Use webpack's require.context to get all files from the interior folder
        const context = require.context('../assets/interior', false, /\.(jpeg|jpg|png|gif|webp)$/i);
        const imageModules = context.keys().map(key => ({
          src: context(key),
          alt: `Highlands interior - ${key.replace('./', '').replace(/\.(jpeg|jpg|png|gif|webp)$/i, '')}`
        }));
        setImages(imageModules);
      } catch (error) {
        console.error('Error loading interior images:', error);
      }
    };

    importAllImages();
  }, []);

  return (
    <section className="grid-section">
      <div className="grid-content">
        <div className="grid-header">
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        <div className="grid-container two-column">
          {images.map((image, index) => (
            <div key={index} className="grid-item">
              <img src={image.src} alt={image.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InteriorGallery; 